import {
  //Action,
  ActionType
  //BookingInfo
} from '../model/model'
import bookingInfoApi from '../services/bookingInfoApi'
import keysToCamel from '../helpers/keysToCamel'

export const fetchBookingInfo = (
  venue_id: String | Number,
  from_date: String,
  to_date: String
) => async (dispatch: Function) => {
  dispatch({ type: ActionType.FETCHING_BOOKINGINFO })

  try {
    const { data } = await bookingInfoApi.get(
      `/supplier/statistics?venue_id=${venue_id}&from_date=${from_date}&to_date=${to_date}`
    )
    dispatch({
      type: ActionType.FETCH_BOOKINGINFO_SUCCESS,
      payload: keysToCamel(data)
    })
  } catch (error) {
    dispatch({
      type: ActionType.FETCH_BOOKINGINFO_FAIL,
      payload: error.response
    })
  }
}
